export default {
  common__validation__is_required: 'maydon talab qilinadi',
  common__validation__invalid_format: "Noto'g'ri qiymat",
  common__validation__invalid_file_size: 'Fayl hajmi maksimal chegaradan ({size}) oshib ketdi',
};
